Object.defineProperty(exports, "__esModule", { value: true });
var Fonts;
(function (Fonts) {
    Fonts["Titillium"] = "Titillium Web";
})(Fonts = exports.Fonts || (exports.Fonts = {}));
//# sourceMappingURL=typography.js.map